import {ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction} from "core/actions";
import {assertArray} from "core/validation";
import {getNumberFromSub} from "components/global/RatingCategorySelect";
import {RATING_CATEGORIES, RATING_SUB_CATEGORIES_REPORT} from "core/dataConstants";
import {INTERVALS} from "components/common/dateUtils";

export const FILM_RELEASE_REPORT_SEARCH_FORM = {
    dateInterval: {
        value: INTERVALS.CURRENT_MONTH,
        dateFrom: null,
        dateTo: null,
    },
    companies: [],
    ratingCategory: null,
    ratingSubCategory: []
};
export const initState = {
    reviewUserForm: {
        dateInterval: {
            value: INTERVALS.CURRENT_MONTH,
            dateFrom: null,
            dateTo: null,
        },
        users: [],
        companies: [],
        statuses: [],
        countAllVersions: false
    },
    reviewUserQueryStatus: ACTION_STATES.NO_REQUEST,
    reviewUserData: [],
    statusLastSearch: [],
    usersLastSearch: [],
    tagsForm: {
        dateInterval: {
            value: INTERVALS.CURRENT_MONTH,
            dateFrom: null,
            dateTo: null,
        },
        companies: [],
        tags: [],
        advTypes: [],
    },
    tagsData: [],
    tagsQueryStatus: ACTION_STATES.NO_REQUEST,

    filmReleaseForm: FILM_RELEASE_REPORT_SEARCH_FORM,
    filmQueryStatus: ACTION_STATES.NO_REQUEST,
    filmReportData:[]
};

export class ON_CHANGE_REVIEW_FORM extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            reviewUserForm: {
                ...state.reviewUserForm,
                ...payload,
            },
        });
    }
}

export class RUN_REVIEW_USER_QUERY extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            reviewUserQueryStatus: ACTION_STATES.SEND,
            statusLastSearch: state.reviewUserForm.statuses,
            usersLastSearch: state.reviewUserForm.users,
        });
    }

    successRdx(state, { payload }) {
        const reviewUserData = transformDataToReviewUserChart(payload.data);

        return Object.assign({}, state, {
            reviewUserData,
            reviewUserQueryStatus: ACTION_STATES.SUCCESS,
        });
    }
}
export class ON_CLEAR_REVIEW_FORM extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            reviewUserForm: initState.reviewUserForm,
            statusLastSearch: [],
            usersLastSearch: [],
        });
    }
}

export class ON_CHANGE_TAGS_FORM extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            tagsForm: {
                ...state.tagsForm,
                ...payload,
            },
        });
    }
}
export class ON_CLEAR_TAGS_FORM extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            tagsForm: initState.tagsForm,
        });
    }
}

export class RUN_TAGS_QUERY extends ComplexAction {
    successRdx(state, { payload }) {
        const tagsData = transformDataToTagsChart(payload.data);
        return Object.assign({}, state, {
            tagsData,
            tagsQueryStatus: ACTION_STATES.SUCCESS,
        });
    }
}



export class RUN_CATEGORY_REPORT_QUERY_REPORT  extends ComplexAction {
    sendRdx(state, {payload}) {
        return Object.assign({}, state, {
            filmReleaseForm: {
                ...state.filmReleaseForm,
                ...payload,
            },
        });
    }

    successRdx(state, { payload }) {
        const filmReportData = transformDataToTagsChart(payload.data);
        return Object.assign({}, state, {
            filmReportData,
            filmQueryStatus: ACTION_STATES.SUCCESS,
        });
    }
}

export const actions = {
    ON_CHANGE_REVIEW_FORM: new ON_CHANGE_REVIEW_FORM(),
    ON_CLEAR_REVIEW_FORM: new ON_CLEAR_REVIEW_FORM(),
    RUN_REVIEW_USER_QUERY: new RUN_REVIEW_USER_QUERY({ loadingAtr: "reviewUserQueryStatus" }),

    ON_CHANGE_TAGS_FORM: new ON_CHANGE_TAGS_FORM(),
    ON_CLEAR_TAGS_FORM: new ON_CLEAR_TAGS_FORM(),
    RUN_TAGS_QUERY: new RUN_TAGS_QUERY({ loadingAtr: "tagsQueryStatus" }),

    RUN_CATEGORY_REPORT_QUERY_REPORT: new RUN_CATEGORY_REPORT_QUERY_REPORT({loadingAtr:"filmQueryStatus"})
};

const handlers = createHandler(actions);

export const reducer = createReducer(initState, handlers);
export default actions;

export function transformDataToReviewUserChart(data) {
    if (!assertArray(data)) {
        return [];
    }
    const result = [];
    data.map((d) => {
        let statuses = {};
        let hasData = false;
        d.reviews
            .filter((s) => s.statusName !== "")
            .map((s) => {
                if (s.count > 0) {
                    hasData = true;
                }
                const key = getReviewUserStatusKey(s.statusId);
                statuses = {
                    ...statuses,
                    [key]: s.count,
                };
            });
        let lastName = d.user.lastName ? d.user.lastName.substr(0, 1) + "." : "";
        if (hasData) {
            result.push({
                ...d,
                name: d.user.firstName + ", " + lastName,
                ...statuses,
            });
        }

    });
    return result;
}
export const getReviewUserStatusKey = (id) => "status_" + id;

export function transformDataToTagsChart(array) {
    return assertArray(array) ? array.map((t) => ({ ...t, name: t.tagName })) : [];
}
export function transformDataToFilmReportChart(data) {
    const chartData = [];
    RATING_CATEGORIES.map(cat => {
        const valueObj = {};
        RATING_SUB_CATEGORIES_REPORT.map(k => {
            valueObj[k.id] = 0;
            valueObj.total = 0;
        });
        chartData.push({
            ratingCategory:cat.value,
            ...valueObj
        });
    });
    if (assertArray(data)) {
        data.map((d) => {
            const valueObj = chartData.find(c => c.ratingCategory === d.ratingCategory);

            Object.keys(d.subCategories).map(key => {
                const keyS = `rating_${getNumberFromSub(key).subCategory}`;
                valueObj[keyS] = d.subCategories[key];
                valueObj.total+= d.subCategories[key];
            });


        });
    }
    return chartData;
}
